


















import Vue from "vue";
import axios from "../../../rest.config";
import { AdminService, PuzzleService } from "../../services";
import AdminPuzzleItem from "@/components/Admin/AdminPuzzleItem.vue";

export default Vue.extend({
  name: "All",
  components: {
    AdminPuzzleItem
  },
  data() {
    return {
      puzzles: [],
      confirmData: "",
      modalHeader: "",
      modalMessage: ""
    };
  },
  computed: {},
  created: async function () {
    let response = await AdminService.getAllPuzzles();

    this.puzzles = [];
    this.puzzles = response;
  },
  methods: {
    deletePuzzle: function (event: any): void {
      this.confirmData = event.id;
      this.modalHeader = "Ta bort kryss?";
      this.modalMessage = `Vill du verkligen ta bort ${event.name}?`;
    },
    confirmDelete: async function (confirmation: any): Promise<void> {
      this.closeModal();
      try {
        if (confirmation.choice) {
          await PuzzleService.deletePuzzle(confirmation.data);
          window.location.reload();
        }
      } catch (error: any) {
        console.log(error);
      }
    },
    closeModal: function (): void {
      this.modalHeader = "";
      this.modalMessage = "";
    }
  }
});
